import { EDUCATION_BASE_PATH } from '@/config/baseModulesLink';
import { PROFILE_PATH } from '../Dashboard/DashboardLinks';

export const EDUCATION_LIST_PATH = 'list';
const base = `/${PROFILE_PATH}`;

export const EDUCATION_LINKS = {
  education: `${base}/${EDUCATION_BASE_PATH}`,
  detail: (id: number) => `${base}/${EDUCATION_BASE_PATH}/${id}`,
  educationList: `${base}/${EDUCATION_BASE_PATH}/${EDUCATION_LIST_PATH}`,
};
